<template>
  <div class="privilege-panel" :class="{ embedded: embedded }">
    <!-- 顶部标签 -->
    <div class="privilege-tabs">
      <span class="privilege-tab" :class="{ active: activeTab === 'guard' }" @click="activeTab = 'guard'">守护管理</span>
      <span class="privilege-tab" :class="{ active: activeTab === 'badge' }" @click="activeTab = 'badge'">粉丝徽章</span>
      <span class="privilege-tab" :class="{ active: activeTab === 'guild' }" @click="activeTab = 'guild'">公会管理</span>
      <span class="privilege-tab" :class="{ active: activeTab === 'vip' }" @click="activeTab = 'vip'">公会贵宾</span>
    </div>

    <!-- 守护管理 -->
    <div v-if="activeTab === 'guard'" class="tab-content">
      <div class="section-title-sm">
        我守护的主播
        <span class="guard-scope-tag">专属主播</span>
      </div>

      <!-- 我守护的主播列表 -->
      <div v-if="myGuardAnchors.length > 0" class="my-anchor-guard-list">
        <div class="anchor-guard-card" v-for="(ag, i) in myGuardAnchors" :key="ag.id || (ag.anchor_id + '-' + i)">
          <img :src="ag.anchor_avatar || logo" class="anchor-guard-avatar" @error="handleImgError" alt="">
          <div class="anchor-guard-info">
            <div class="anchor-guard-name">
              {{ ag.anchor_name || '主播' }}
              <span class="anchor-guard-level" :class="'level-' + ag.level">Lv{{ ag.level }}</span>
            </div>
            <div class="anchor-guard-meta">
              <span v-if="ag.days_left >= 0">剩余 {{ ag.days_left }} 天</span>
              <span v-else>永久</span>
              <span v-if="ag.expiretime && ag.expiretime !== '永久'">到期 {{ ag.expiretime }}</span>
            </div>
          </div>
          <button class="enter-room-btn" @click="goLiveRoom(ag.room_id)">进入直播间</button>
        </div>
      </div>
      <div v-else class="empty-guard-box">
        <p>您还未守护任何主播</p>
        <p class="empty-guard-tip">进入主播直播间，在工具栏点击"守护"即可开通</p>
      </div>

      <!-- 守护等级说明 -->
      <div class="section-title-sm" style="margin-top:20px;">守护等级说明</div>
      <div class="guard-banner">
        <div class="banner-text">
          <h3>魅力守护 全新绽放</h3>
          <div class="banner-tags">
            <span>专属入场</span>
            <span>主播专属</span>
            <span>贵宾特权</span>
            <span>永恒诺言</span>
          </div>
        </div>
        <div class="banner-wing">
          <svg viewBox="0 0 200 120" width="160" height="96" fill="none">
            <path d="M20 60c30-40 80-50 100-50s20 20 20 20-50 10-80 50-40 40-40 40Z" fill="rgba(255,255,255,0.25)"/>
            <path d="M180 60c-30-40-80-50-100-50s-20 20-20 20 50 10 80 50 40 40 40 40Z" fill="rgba(255,255,255,0.18)"/>
          </svg>
        </div>
      </div>
      <div class="guard-list">
        <div class="guard-card" v-for="(g, i) in guardList" :key="i">
          <div class="guard-level" :class="'level-' + g.level">{{ g.level }}级</div>
          <div class="guard-name">{{ g.name }}</div>
          <div class="guard-price">{{ g.price }}</div>
          <div class="guard-privileges">
            <span v-for="(p, j) in g.privileges" :key="j">{{ p }}</span>
          </div>
          <button class="guard-btn" @click="buyGuard(g)">前往直播间开通</button>
        </div>
      </div>
    </div>

    <!-- 粉丝徽章 -->
    <div v-if="activeTab === 'badge'" class="tab-content">
      <div class="section-title-sm">我的粉丝徽章</div>
      <div v-if="myBadges.length === 0" class="empty-box">
        <img :src="logo" alt="">
        <p>暂无粉丝徽章，给喜欢的主播送礼物可获得粉丝徽章</p>
        <div class="fan-club-tip">
          <p class="fan-club-tip-title">加入粉丝团，享受专属特权</p>
          <ul class="fan-club-tip-list">
            <li>获得专属粉丝徽章，点亮身份标识</li>
            <li>专属粉丝进场特效，全场瞩目</li>
            <li>粉丝团专属表情包与互动道具</li>
            <li>升级徽章解锁更多专属特权</li>
          </ul>
          <button class="action-btn" @click="goLiveSquare">前往直播间加入粉丝团</button>
        </div>
      </div>
      <div v-else class="badge-list">
        <div class="badge-card" v-for="(b, i) in myBadges" :key="i">
          <img :src="avatarUrl(b.anchor_avatar)" class="badge-avatar" @error="handleImgError" alt="">
          <div class="badge-icon" :style="{ background: b.color }">{{ b.level }}</div>
          <div class="badge-info">
            <div class="badge-name">{{ b.name }}</div>
            <div class="badge-room">{{ b.room_name || b.anchor_name || '灵眸直播间' }}</div>
          </div>
          <div class="badge-exp">
            <div class="exp-bar"><div class="exp-fill" :style="{ width: b.exp_percent + '%' }"></div></div>
            <span>{{ b.exp }}/{{ b.next_exp }}</span>
          </div>
          <div class="badge-actions">
            <button
              v-if="canUpgradeBadge(b)"
              class="badge-upgrade-btn"
              :disabled="badgeUpgrading"
              @click="handleUpgradeBadge(b)"
            >
              <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
                <polyline points="17 6 23 6 23 12"/>
              </svg>
              升级
            </button>
            <button
              v-else
              class="badge-upgrade-btn disabled"
              disabled
              title="经验不足，无法升级"
            >
              经验不足
            </button>
            <button
              class="badge-room-btn"
              @click="goLiveRoom(b.room_id || b.id)"
            >进入直播间</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 公会管理 -->
    <div v-if="activeTab === 'guild'" class="tab-content">
      <div class="section-title-sm">我的公会</div>
      <div v-if="!myGuild" class="empty-box">
        <img :src="logo" alt="">
        <p>您暂未加入任何公会</p>
        <div class="guild-empty-actions">
          <button class="action-btn" @click="showCreateGuildForm = true">创建公会</button>
          <button class="action-btn plain" @click="showJoinGuild = true">申请加入公会</button>
        </div>
      </div>
      <div v-else>
        <div class="guild-card">
          <img :src="myGuild.logo || logo" class="guild-logo" @error="handleImgError" alt="">
          <div class="guild-info">
            <div class="guild-name">{{ myGuild.name }}</div>
            <div class="guild-meta">
              <span>会长：{{ myGuild.leader }}</span>
              <span>成员：{{ myGuild.members }}人</span>
            </div>
          </div>
          <div class="guild-card-actions">
            <button v-if="isGuildLeader" class="action-btn" @click="handleGuildManage">公会管理</button>
            <button v-else class="action-btn plain" @click="exitGuild">退出公会</button>
          </div>
        </div>

        <!-- 公会管理面板 -->
        <div v-if="showGuildManage && isGuildLeader" class="guild-manage-panel">
          <div class="guild-manage-title">
            成员列表
            <span class="guild-manage-count">共 {{ guildMembers.length }} 人</span>
          </div>
          <div v-if="guildMembers.length === 0" class="mini-empty">暂无成员</div>
          <div v-else class="guild-member-list">
            <div class="guild-member-item" v-for="m in guildMembers" :key="m.user_id || m.id">
              <img :src="m.avatar || logo" class="guild-member-avatar" @error="handleImgError" alt="">
              <div class="guild-member-info">
                <div class="guild-member-name">{{ m.nickname || m.username }}</div>
                <div class="guild-member-role">{{ isMemberLeader(m) ? '会长' : '成员' }}</div>
              </div>
              <div class="guild-member-actions" v-if="!isMemberLeader(m)">
                <button class="member-btn transfer" @click="handleTransferLeader(m.user_id || m.id)">转让会长</button>
                <button class="member-btn remove" @click="handleRemoveMember(m.user_id || m.id)">移除</button>
              </div>
            </div>
          </div>
          <div class="guild-manage-footer">
            <button class="action-btn danger" @click="handleDisbandGuild">解散公会</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 公会贵宾 -->
    <div v-if="activeTab === 'vip'" class="tab-content">
      <div class="section-title-sm">公会贵宾特权</div>
      <div class="vip-list">
        <div class="vip-card" v-for="(v, i) in vipList" :key="i">
          <div class="vip-icon" :style="{ background: v.color }">
            <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor"><path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z"/></svg>
          </div>
          <div class="vip-name">{{ v.name }}</div>
          <div class="vip-desc">{{ v.desc }}</div>
          <button class="vip-btn" @click="showVipDetail(v)">了解详情</button>
        </div>
      </div>
    </div>

    <!-- 申请加入公会弹窗 -->
    <div v-if="showJoinGuild" class="modal-overlay" @click="showJoinGuild = false">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">申请加入公会</h3>
        <div class="guild-search-wrap">
          <input type="text" v-model="guildSearch" placeholder="搜索公会名称或ID" class="guild-search" @keyup.enter="handleSearchGuild">
          <button class="search-btn" @click="handleSearchGuild">搜索</button>
        </div>
        <div class="guild-result">
          <div v-if="guildResults.length === 0" class="mini-empty">输入公会名称或ID进行搜索</div>
          <div v-else>
            <div class="guild-result-item" v-for="g in guildResults" :key="g.id"
                 :class="{ selected: selectedGuildId === g.id }"
                 @click="selectedGuildId = g.id">
              <img :src="g.logo || logo" class="guild-result-logo" @error="handleImgError" alt="">
              <div class="guild-result-info">
                <div class="guild-result-name">{{ g.name }}</div>
                <div class="guild-result-meta">会长：{{ g.leader || '-' }} | 成员：{{ g.members || 0 }}人</div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-actions">
          <button class="cancel-btn" @click="showJoinGuild = false">取消</button>
          <button class="confirm-btn" @click="handleJoinGuild" :disabled="!selectedGuildId">加入公会</button>
        </div>
      </div>
    </div>

    <!-- 创建公会弹窗 -->
    <div v-if="showCreateGuildForm" class="modal-overlay" @click="showCreateGuildForm = false">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">创建公会</h3>
        <div class="guild-form-row">
          <label>公会名称</label>
          <input type="text" v-model="guildForm.name" placeholder="请输入公会名称" class="guild-search" maxlength="20">
        </div>
        <div class="guild-form-row">
          <label>公会简介</label>
          <textarea v-model="guildForm.description" placeholder="请输入公会简介" rows="3" class="guild-textarea"></textarea>
        </div>
        <div class="guild-form-row">
          <label>公会Logo（选填）</label>
          <input type="text" v-model="guildForm.logo" placeholder="请输入Logo地址" class="guild-search">
        </div>
        <div class="modal-actions">
          <button class="cancel-btn" @click="showCreateGuildForm = false">取消</button>
          <button class="confirm-btn" @click="handleCreateGuild">创建公会</button>
        </div>
      </div>
    </div>

    <!-- 贵宾详情弹窗 -->
    <div v-if="showVipModal && currentVip" class="modal-overlay" @click="showVipModal = false">
      <div class="modal-content" @click.stop>
        <h3 class="modal-title">{{ currentVip.name }}</h3>
        <div class="vip-detail">
          <div class="vip-detail-icon" :style="{ background: currentVip.color }">
            <svg viewBox="0 0 24 24" width="40" height="40" fill="currentColor"><path d="M12 2l2.4 7.2h7.6l-6 4.8 2.4 7.2-6-4.8-6 4.8 2.4-7.2-6-4.8h7.6z"/></svg>
          </div>
          <p class="vip-detail-desc">{{ currentVip.desc }}</p>
          <p class="vip-detail-price">价格：{{ currentVip.price || '暂未定价' }}</p>
          <div class="vip-detail-privileges">
            <h4>专属特权</h4>
            <ul>
              <li>公会专属标识，彰显贵宾身份</li>
              <li>优先进入主播直播间</li>
              <li>解锁公会专属礼物</li>
              <li>享受公会活动优先参与权</li>
              <li>专属客服服务</li>
            </ul>
          </div>
        </div>
        <div class="modal-actions">
          <button class="cancel-btn" @click="showVipModal = false">关闭</button>
          <button class="confirm-btn" @click="handleBuyVip">立即开通</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, computed, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { getGuardList, getMyBadges, getMyGuild, searchGuild, joinGuild, exitGuild as apiExitGuild, getVipList, joinFanClub, upgradeBadge, createGuild, getGuildMembers, removeGuildMember, disbandGuild, transferLeader, getMyGuardAnchors } from '../api/title';
import { useUserStore } from '../stores/user';
import { BASE_URL } from '../api/config';

const logo = require('../assets/logo.png');

const avatarUrl = (url) => {
  if (!url) return logo;
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  return `${BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
};

export default {
  name: 'TitlePanel',
  props: {
    embedded: { type: Boolean, default: false }
  },
  setup() {
    const router = useRouter();
    const userStore = useUserStore();
    const activeTab = ref('guard');
    const showJoinGuild = ref(false);
    const guildSearch = ref('');
    const guildResults = ref([]);
    const selectedGuildId = ref(null);
    const badgeUpgrading = ref(false);

    const guardList = ref([]);
    const guardScope = ref('专属主播');
    const topGuardLevel = ref(0);
    const myGuardAnchors = ref([]);
    const myBadges = ref([]);
    const myGuild = ref(null);
    const vipList = ref([]);

    const showVipModal = ref(false);
    const currentVip = ref(null);

    // 公会管理
    const showCreateGuildForm = ref(false);
    const guildForm = ref({ name: '', description: '', logo: '' });
    const guildMembers = ref([]);
    const showGuildManage = ref(false);

    const isGuildLeader = computed(() => {
      if (!myGuild.value) return false;
      const userId = userStore.userInfo?.id;
      if (!userId) return false;
      return Number(myGuild.value.leader_id) === Number(userId) ||
             Number(myGuild.value.user_id) === Number(userId) ||
             myGuild.value.is_leader === true;
    });

    const isMemberLeader = (m) => {
      if (!m || !myGuild.value) return false;
      const memberId = m.user_id || m.id;
      const leaderId = myGuild.value.leader_id || myGuild.value.user_id;
      return Number(memberId) === Number(leaderId);
    };

    const loadGuardList = async () => {
      try {
        // 加载我守护的主播列表
        const res = await getMyGuardAnchors();
        if (res.code === 1) {
          myGuardAnchors.value = res.data || [];
        }
        // 加载守护等级列表（不传anchor_id，仅展示等级说明）
        const levelRes = await getGuardList();
        if (levelRes.code === 1) {
          const d = levelRes.data;
          if (Array.isArray(d)) {
            guardList.value = d;
          } else {
            guardList.value = d?.list || [];
            guardScope.value = d?.scope || '专属主播';
            topGuardLevel.value = d?.top_level || 0;
          }
        }
      } catch (e) { /* ignore */ }
    };

    const loadBadges = async () => {
      try {
        const res = await getMyBadges();
        if (res.code === 1) myBadges.value = res.data || [];
      } catch (e) { /* ignore */ }
    };

    const loadGuild = async () => {
      try {
        const res = await getMyGuild();
        if (res.code === 1) myGuild.value = res.data || null;
      } catch (e) { /* ignore */ }
    };

    const loadVipList = async () => {
      try {
        const res = await getVipList();
        if (res.code === 1) vipList.value = res.data || [];
      } catch (e) { /* ignore */ }
    };

    const buyGuard = () => {
      alert('守护是对特定主播开通的，请进入主播直播间后，在工具栏"守护"中为该主播开通守护。');
    };

    const handleSearchGuild = async () => {
      if (!guildSearch.value.trim()) return;
      try {
        const res = await searchGuild(guildSearch.value.trim());
        if (res.code === 1) guildResults.value = res.data || [];
      } catch (e) {
        guildResults.value = [];
      }
    };

    const handleJoinGuild = async () => {
      if (!selectedGuildId.value) {
        alert('请选择要加入的公会');
        return;
      }
      try {
        const res = await joinGuild(selectedGuildId.value);
        if (res.code === 1) {
          alert('加入成功');
          showJoinGuild.value = false;
          selectedGuildId.value = null;
          guildSearch.value = '';
          guildResults.value = [];
          await loadGuild();
        } else {
          alert(res.msg || '加入失败');
        }
      } catch (e) {
        alert(e.message || '加入失败');
      }
    };

    const exitGuild = async () => {
      if (!confirm('确定退出当前公会？')) return;
      try {
        const res = await apiExitGuild();
        if (res.code === 1) {
          alert('已退出公会');
          myGuild.value = null;
          showGuildManage.value = false;
          guildMembers.value = [];
        } else {
          alert(res.msg || '操作失败');
        }
      } catch (e) {
        alert(e.message || '操作失败');
      }
    };

    const handleCreateGuild = async () => {
      const f = guildForm.value;
      if (!f.name.trim()) { alert('请输入公会名称'); return; }
      try {
        const res = await createGuild({
          name: f.name.trim(),
          description: f.description.trim(),
          logo: f.logo.trim()
        });
        if (res.code === 1) {
          alert('公会创建成功');
          showCreateGuildForm.value = false;
          guildForm.value = { name: '', description: '', logo: '' };
          await loadGuild();
        } else {
          alert(res.msg || '创建失败');
        }
      } catch (e) {
        alert(e.message || '创建失败');
      }
    };

    const fetchGuildMembers = async () => {
      if (!myGuild.value) return;
      try {
        const res = await getGuildMembers({ guild_id: myGuild.value.id });
        if (res.code === 1) guildMembers.value = res.data?.list || res.data || [];
      } catch (e) { /* ignore */ }
    };

    const handleGuildManage = async () => {
      showGuildManage.value = !showGuildManage.value;
      if (showGuildManage.value) {
        await fetchGuildMembers();
      }
    };

    const handleRemoveMember = async (userId) => {
      if (!confirm('确定移除该成员？')) return;
      try {
        const res = await removeGuildMember(myGuild.value.id, userId);
        if (res.code === 1) {
          alert('已移除该成员');
          await fetchGuildMembers();
          await loadGuild();
        } else {
          alert(res.msg || '操作失败');
        }
      } catch (e) {
        alert(e.message || '操作失败');
      }
    };

    const handleDisbandGuild = async () => {
      if (!confirm('确定解散公会？此操作不可恢复！')) return;
      try {
        const res = await disbandGuild(myGuild.value.id);
        if (res.code === 1) {
          alert('公会已解散');
          myGuild.value = null;
          showGuildManage.value = false;
          guildMembers.value = [];
        } else {
          alert(res.msg || '操作失败');
        }
      } catch (e) {
        alert(e.message || '操作失败');
      }
    };

    const handleTransferLeader = async (userId) => {
      if (!confirm('确定将会长转让给该成员？')) return;
      try {
        const res = await transferLeader(myGuild.value.id, userId);
        if (res.code === 1) {
          alert('会长已转让');
          showGuildManage.value = false;
          await loadGuild();
        } else {
          alert(res.msg || '操作失败');
        }
      } catch (e) {
        alert(e.message || '操作失败');
      }
    };

    const handleImgError = (e) => { e.target.src = logo; };

    // 判断徽章是否可升级（经验满足升级条件）
    const canUpgradeBadge = (b) => {
      if (!b) return false;
      const exp = Number(b.exp) || 0;
      const nextExp = Number(b.next_exp) || 0;
      return nextExp > 0 && exp >= nextExp;
    };

    const handleJoinFanClub = async (roomId) => {
      if (!roomId) {
        alert('请前往直播间加入粉丝团');
        return;
      }
      if (!confirm('确定加入该主播的粉丝团？')) return;
      badgeUpgrading.value = true;
      try {
        const res = await joinFanClub(roomId);
        if (res.code === 1) {
          alert('加入粉丝团成功');
          await loadBadges();
        } else {
          alert(res.msg || '加入失败');
        }
      } catch (e) {
        alert(e.message || '加入失败');
      } finally {
        badgeUpgrading.value = false;
      }
    };

    const handleUpgradeBadge = async (b) => {
      const roomId = b.room_id || b.id;
      if (!roomId) {
        alert('无法识别直播间');
        return;
      }
      if (!canUpgradeBadge(b)) {
        alert('经验不足，无法升级');
        return;
      }
      if (!confirm(`确定升级 ${b.name || '粉丝徽章'}？`)) return;
      badgeUpgrading.value = true;
      try {
        const res = await upgradeBadge(roomId);
        if (res.code === 1) {
          alert('升级成功！' + (res.data?.message || ''));
          await loadBadges();
        } else {
          alert(res.msg || '升级失败');
        }
      } catch (e) {
        alert(e.message || '升级失败');
      } finally {
        badgeUpgrading.value = false;
      }
    };

    const goLiveRoom = (roomId) => {
      if (!roomId) {
        alert('无法识别直播间');
        return;
      }
      router.push({ name: 'LiveRoomDetail', params: { id: roomId } });
    };

    // 未加入粉丝团时，跳转直播间广场选择主播
    const goLiveSquare = () => {
      router.push({ name: 'LiveSquare' });
    };

    const showVipDetail = (v) => {
      currentVip.value = v;
      showVipModal.value = true;
    };

    const handleBuyVip = () => {
      alert('开通成功，请前往充值');
      showVipModal.value = false;
    };

    const loadTabData = (tab) => {
      if (tab === 'guard') loadGuardList();
      else if (tab === 'badge') loadBadges();
      else if (tab === 'guild') loadGuild();
      else if (tab === 'vip') loadVipList();
    };

    watch(activeTab, (newTab) => loadTabData(newTab));

    onMounted(() => {
      userStore.initUserInfo();
      loadGuardList();
      loadBadges();
      loadGuild();
      loadVipList();
    });

    return {
      activeTab, showJoinGuild, guildSearch, guildResults, selectedGuildId,
      guardList, guardScope, topGuardLevel, myGuardAnchors, myBadges, myGuild, vipList,
      showVipModal, currentVip,
      buyGuard, handleSearchGuild, handleJoinGuild, exitGuild, handleImgError, avatarUrl,
      showVipDetail, handleBuyVip,
      canUpgradeBadge, handleJoinFanClub, handleUpgradeBadge, goLiveRoom, goLiveSquare,
      badgeUpgrading,
      // 公会管理
      showCreateGuildForm, guildForm, guildMembers, showGuildManage,
      isGuildLeader, isMemberLeader,
      handleCreateGuild, fetchGuildMembers, handleGuildManage,
      handleRemoveMember, handleDisbandGuild, handleTransferLeader,
      logo
    };
  }
};
</script>

<style scoped>
.privilege-panel {
  padding: 20px;
}
.privilege-panel.embedded {
  padding: 20px 24px;
}

/* 顶部标签 */
.privilege-tabs {
  display: flex;
  gap: 24px;
  border-bottom: 1px solid #f0f0f0;
  margin-bottom: 24px;
}
.privilege-tab {
  padding: 10px 4px;
  font-size: 15px;
  color: #666;
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
}
.privilege-tab:hover {
  color: #ff6a00;
}
.privilege-tab.active {
  color: #ff6a00;
  font-weight: 700;
}
.privilege-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  border-radius: 2px 2px 0 0;
}

.section-title-sm {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.guard-scope-tag {
  display: inline-block;
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
  color: #ff6a00;
  background: #fff3e6;
  border-radius: 8px;
}

/* 我守护的主播列表 */
.my-anchor-guard-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;
}
.anchor-guard-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 14px 16px;
  background: linear-gradient(135deg, #fff6ef, #fff);
  border: 1px solid #ffe4cc;
  border-radius: 12px;
  transition: all 0.25s;
}
.anchor-guard-card:hover {
  border-color: #ff9600;
  box-shadow: 0 4px 12px rgba(255, 106, 0, 0.1);
}
.anchor-guard-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff3e6;
  flex-shrink: 0;
}
.anchor-guard-info {
  flex: 1;
  min-width: 0;
}
.anchor-guard-name {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a2e;
  display: flex;
  align-items: center;
  gap: 6px;
}
.anchor-guard-level {
  display: inline-block;
  padding: 1px 8px;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  border-radius: 8px;
}
.anchor-guard-level.level-1 { background: #94a3b8; }
.anchor-guard-level.level-2 { background: #3b82f6; }
.anchor-guard-level.level-3 { background: #ff8c00; }
.anchor-guard-level.level-4 { background: #ef4444; }
.anchor-guard-meta {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
  display: flex;
  gap: 12px;
}
.enter-room-btn {
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  border: none;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.2s;
  flex-shrink: 0;
}
.enter-room-btn:hover { transform: translateY(-1px); box-shadow: 0 4px 10px rgba(255, 106, 0, 0.3); }

.empty-guard-box {
  padding: 30px 16px;
  text-align: center;
  background: #fafafa;
  border: 1px dashed #e0e0e0;
  border-radius: 12px;
  margin-bottom: 20px;
}
.empty-guard-box p { font-size: 14px; color: #888; margin: 0 0 6px; }
.empty-guard-tip { font-size: 12px !important; color: #bbb !important; }

/* 守护 banner */
.guard-banner {
  position: relative;
  height: 130px;
  border-radius: 10px;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  margin-bottom: 24px;
  overflow: hidden;
}
.guard-banner::before {
  content: '';
  position: absolute;
  right: -40px;
  top: -40px;
  width: 220px;
  height: 220px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 50%;
}
.banner-text {
  position: relative;
  z-index: 1;
}
.banner-text h3 {
  margin: 0 0 12px;
  font-size: 28px;
  font-weight: 800;
  color: #fff;
  text-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}
.banner-tags {
  display: flex;
  gap: 12px;
}
.banner-tags span {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
  color: #fff;
}
.banner-tags span::before {
  content: '♥';
  color: #ffd700;
  font-size: 12px;
}
.banner-wing {
  position: relative;
  z-index: 1;
  opacity: 0.7;
}

/* 守护列表 */
.guard-list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
}
.guard-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 18px;
  text-align: center;
  transition: all 0.25s;
}
.guard-card:hover {
  border-color: #ffd8b2;
  box-shadow: 0 4px 16px rgba(255, 106, 0, 0.1);
}
.guard-level {
  display: inline-block;
  padding: 3px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 10px;
}
.guard-level.level-1 { background: #94a3b8; }
.guard-level.level-2 { background: #3b82f6; }
.guard-level.level-3 { background: #ff8c00; }
.guard-level.level-4 { background: #ef4444; }
.guard-name {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  margin-bottom: 4px;
}
.guard-price {
  font-size: 13px;
  color: #ff6a00;
  font-weight: 600;
  margin-bottom: 10px;
}
.guard-privileges {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #999;
  margin-bottom: 14px;
}
.guard-btn {
  width: 100%;
  padding: 8px 0;
  border: none;
  border-radius: 6px;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.guard-btn:hover:not(:disabled) {
  opacity: 0.9;
}
.guard-btn.owned {
  background: #e0e0e0;
  color: #999;
  cursor: not-allowed;
}

/* 粉丝徽章 */
.badge-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.badge-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
}
.badge-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  border: 2px solid #ff9600;
}
.badge-icon {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  flex-shrink: 0;
}
.badge-info {
  flex: 1;
}
.badge-name {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  margin-bottom: 3px;
}
.badge-room {
  font-size: 12px;
  color: #999;
}
.badge-exp {
  width: 180px;
  display: flex;
  align-items: center;
  gap: 8px;
}
.exp-bar {
  flex: 1;
  height: 6px;
  background: #eee;
  border-radius: 3px;
  overflow: hidden;
}
.exp-fill {
  height: 100%;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  border-radius: 3px;
}
.badge-exp span {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
}

/* 粉丝徽章操作按钮 */
.badge-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.badge-upgrade-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(90deg, #ff6a00, #ff9600);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.badge-upgrade-btn:hover:not(:disabled) {
  opacity: 0.9;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(255, 106, 0, 0.3);
}
.badge-upgrade-btn:disabled {
  cursor: not-allowed;
}
.badge-upgrade-btn.disabled {
  background: #f0f0f0;
  color: #999;
}
.badge-room-btn {
  padding: 6px 14px;
  border: 1px solid #ff9600;
  border-radius: 6px;
  background: #fff;
  color: #ff9600;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.badge-room-btn:hover {
  background: #ff9600;
  color: #fff;
}

/* 加入粉丝团说明 */
.fan-club-tip {
  margin-top: 10px;
  padding: 20px;
  background: linear-gradient(135deg, #fff8f0, #fff);
  border: 1px solid #ffe8d6;
  border-radius: 10px;
  text-align: left;
  max-width: 480px;
}
.fan-club-tip-title {
  margin: 0 0 12px;
  font-size: 15px;
  font-weight: 700;
  color: #ff6a00;
  text-align: center;
}
.fan-club-tip-list {
  margin: 0 0 16px;
  padding: 0 0 0 18px;
  list-style: none;
}
.fan-club-tip-list li {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  position: relative;
  padding-left: 14px;
}
.fan-club-tip-list li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #ff6a00;
  font-weight: 700;
}
.fan-club-tip .action-btn {
  display: block;
  margin: 0 auto;
}

/* 公会 */
.guild-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
}
.guild-logo {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  object-fit: cover;
  background: #f0f0f0;
}
.guild-info {
  flex: 1;
}
.guild-name {
  font-size: 16px;
  font-weight: 700;
  color: #333;
  margin-bottom: 6px;
}
.guild-meta {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #999;
}
.action-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  background: #ff9600;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.action-btn.plain {
  background: #fff;
  border: 1px solid #ddd;
  color: #666;
}
.action-btn.plain:hover {
  border-color: #ef4444;
  color: #ef4444;
}
.action-btn.danger {
  background: #fff;
  border: 1px solid #ef4444;
  color: #ef4444;
}
.action-btn.danger:hover {
  background: #ef4444;
  color: #fff;
}

/* 公会管理 */
.guild-empty-actions {
  display: flex;
  gap: 12px;
  margin-top: 4px;
}
.guild-card-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.guild-manage-panel {
  margin-top: 16px;
  padding: 20px;
  background: #fafafa;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
}
.guild-manage-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 700;
  color: #333;
  margin-bottom: 14px;
  padding-left: 10px;
  border-left: 3px solid #ff9600;
}
.guild-manage-count {
  font-size: 12px;
  color: #999;
  font-weight: normal;
}
.guild-member-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.guild-member-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  background: #fff;
  border-radius: 8px;
  border: 1px solid #f0f0f0;
  transition: all 0.2s;
}
.guild-member-item:hover {
  border-color: #ffe4cc;
}
.guild-member-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #f0f0f0;
  flex-shrink: 0;
}
.guild-member-info {
  flex: 1;
}
.guild-member-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
  margin-bottom: 2px;
}
.guild-member-role {
  font-size: 12px;
  color: #999;
}
.guild-member-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.member-btn {
  padding: 5px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.member-btn.transfer {
  color: #ff9600;
  border-color: #ff9600;
}
.member-btn.transfer:hover {
  background: #ff9600;
  color: #fff;
}
.member-btn.remove {
  color: #ef4444;
  border-color: #ef4444;
}
.member-btn.remove:hover {
  background: #ef4444;
  color: #fff;
}
.guild-manage-footer {
  margin-top: 16px;
  text-align: right;
}

/* 创建公会表单 */
.guild-form-row {
  margin-bottom: 16px;
}
.guild-form-row label {
  display: block;
  font-size: 14px;
  color: #666;
  margin-bottom: 6px;
}
.guild-textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 14px;
  color: #333;
  outline: none;
  box-sizing: border-box;
  resize: vertical;
  font-family: inherit;
  transition: border-color 0.25s;
}
.guild-textarea:focus {
  border-color: #ff9600;
}

/* VIP */
.vip-list {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
}
.vip-card {
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  padding: 24px 18px;
  text-align: center;
  transition: all 0.25s;
}
.vip-card:hover {
  border-color: #ff9600;
  box-shadow: 0 4px 16px rgba(255, 150, 0, 0.1);
}
.vip-icon {
  width: 54px;
  height: 54px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 12px;
  color: #fff;
}
.vip-name {
  font-size: 15px;
  font-weight: 700;
  color: #333;
  margin-bottom: 6px;
}
.vip-desc {
  font-size: 12px;
  color: #999;
  margin-bottom: 14px;
  line-height: 1.5;
}
.vip-btn {
  padding: 6px 16px;
  border: 1px solid #ff9600;
  border-radius: 4px;
  background: #fff;
  color: #ff9600;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.vip-btn:hover {
  background: #ff9600;
  color: #fff;
}

/* 空状态 */
.empty-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 20px;
  background: #fff;
  border: 1px solid #f0f0f0;
  border-radius: 10px;
  color: #999;
}
.empty-box img {
  width: 60px;
  opacity: 0.4;
  margin-bottom: 12px;
}
.empty-box p {
  margin: 0 0 16px;
}

/* 弹窗 */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}
.modal-content {
  background: #fff;
  border-radius: 12px;
  width: 420px;
  max-width: 90%;
  padding: 24px;
}
.modal-title {
  font-size: 17px;
  font-weight: 700;
  color: #333;
  margin: 0 0 16px;
}
.guild-search-wrap {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
}
.guild-search {
  flex: 1;
  padding: 10px 12px;
  border: 1px solid #e5e5e5;
  border-radius: 6px;
  font-size: 14px;
  outline: none;
  box-sizing: border-box;
}
.guild-search:focus {
  border-color: #ff9600;
}
.guild-result {
  min-height: 100px;
  max-height: 240px;
  overflow-y: auto;
  background: #fafafa;
  border-radius: 8px;
  margin-bottom: 16px;
}
.guild-result-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  border-bottom: 1px solid #f0f0f0;
  cursor: pointer;
  transition: background 0.2s;
}
.guild-result-item:hover {
  background: #fff5ed;
}
.guild-result-item.selected {
  background: #fff0e0;
  border-color: #ff9600;
}
.guild-result-logo {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  object-fit: cover;
  background: #f0f0f0;
  flex-shrink: 0;
}
.guild-result-info {
  flex: 1;
}
.guild-result-name {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}
.guild-result-meta {
  font-size: 12px;
  color: #999;
  margin-top: 2px;
}
.search-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 6px;
  background: #ff9600;
  color: #fff;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}
.search-btn:hover {
  background: #ff6a00;
}
.mini-empty {
  padding: 40px 0;
  text-align: center;
  color: #999;
  font-size: 13px;
}
.modal-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.cancel-btn {
  padding: 8px 18px;
  border: 1px solid #ddd;
  border-radius: 4px;
  background: #fff;
  color: #666;
  cursor: pointer;
}
.confirm-btn {
  padding: 8px 18px;
  border: none;
  border-radius: 4px;
  background: #ff9600;
  color: #fff;
  cursor: pointer;
}

@media (max-width: 768px) {
  .guard-list { grid-template-columns: repeat(2, 1fr); }
  .vip-list { grid-template-columns: 1fr; }
  .badge-exp { width: 120px; }
}

/* 贵宾详情弹窗 */
.vip-detail {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 8px 0 16px;
}
.vip-detail-icon {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 16px;
}
.vip-detail-desc {
  font-size: 14px;
  color: #666;
  margin: 0 0 10px;
  line-height: 1.6;
}
.vip-detail-price {
  font-size: 16px;
  font-weight: 700;
  color: #ff6a00;
  margin: 0 0 20px;
}
.vip-detail-privileges {
  width: 100%;
  text-align: left;
  background: #fafafa;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
}
.vip-detail-privileges h4 {
  margin: 0 0 12px;
  font-size: 14px;
  font-weight: 700;
  color: #333;
  padding-left: 10px;
  border-left: 3px solid #ff9600;
}
.vip-detail-privileges ul {
  margin: 0;
  padding: 0 0 0 18px;
  list-style: none;
}
.vip-detail-privileges li {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  position: relative;
  padding-left: 14px;
}
.vip-detail-privileges li::before {
  content: '✓';
  position: absolute;
  left: 0;
  color: #ff6a00;
  font-weight: 700;
}
.vip-detail-privileges li:last-child {
  margin-bottom: 0;
}
</style>
